export default __webpack_public_path__ + "static/Screen-Recording-construction-1247c90a04b085db734a166300c94354.gif";